import { isIsoDateTime } from '../../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../../validation/is-iso-date-time-tz.function';
import { getTimeOffset } from '../../get/get-time-offset.function';
import { isIsoDate } from '../../validation/is-iso-date.function';
import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../../types/iso-date';
import { deconstructDate } from '../../helper/deconstruct-date.function';
import { constructDate } from '../../helper/construct-date.function';

/**
 * Returns the start of the day for the given ISO input.
 * - For date-only (YYYY-MM-DD) -> returns 'YYYY-MM-DD'
 * - For date-time without tz -> returns 'YYYY-MM-DDT00:00:00.000'
 * - For date-time with tz -> returns 'YYYY-MM-DDT00:00:00.000Z|±HH:MM' preserving the original timezone
 */
export function startOfDay<T extends IsoDate | IsoDateTime | IsoDateTimeTz>(input: T): T {
  const deconstructed = deconstructDate(input);
  if (deconstructed._type !== 'date' && deconstructed._type !== 'dateTime' && deconstructed._type !== 'dateTimeTz') {
    throw new Error('startOfDay: invalid ISO date/time string');
  }
  if(deconstructed._type !== 'date') {
    deconstructed.hours = 0;
    deconstructed.minutes = 0;
    deconstructed.seconds = 0;
    deconstructed.milliseconds = 0;
  }
  return constructDate(deconstructed) as unknown as T;
}
